module.exports = __webpack_public_path__ + "img/k.da3e5940.jpg";